import React, { useMemo, useState, useEffect, useRef } from "react"
import "../../CenterAdmin/ManageStaff/ManageStaff.scss"
import { useHistory } from "react-router"
import { GlobalFilter } from "../../../frontDesk/patientDirectory/GlobalFilter"
import {
  getPrescriptions,
} from "../../../../core/services/api"
import { useTable, useSortBy, useGlobalFilter } from "react-table"
import { COLUMNS } from "./PrescriptionsColumns"
import Toast from "../../../../components/Toast"

function ManageStaff() {
  const history = useHistory()
  const [data, setData] = useState([])
  const columns = useMemo(() => COLUMNS, [])
  const componentRef = useRef()
  const [displayToast, toggleDisplayToast] = useState()
  const [isLoading, setIsLoading] = useState<boolean>(false)

  useEffect(() => {
    // setIsLoading(true)
    getPrescriptions()
      .then((res: any) => {
        setData(res)
        setIsLoading(false)
      })
      .catch((err: any) => {
        setIsLoading(false)
        console.log("Err", err)
      })
  }, [])

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    footerGroups,
    rows,
    prepareRow,
    state,
    setGlobalFilter,
  } = useTable(
    {
      columns,
      data,
    },

    useGlobalFilter,
    useSortBy
  )
  const { globalFilter } = state
  /**
   * @param {any} path
   */

  return (
    <div className="manage-staff-patients-container">
      {isLoading && (
        <div
          style={{
            position: "absolute",
            top: "50%",
            right: "50%",
          }}
        >
          <div
            style={{ width: "3rem", height: "3rem" }}
            className="spinner-border text-primary"
          ></div>
        </div>
      )}
      <div className="manage-staff-patients-heading">
        <div
          className="approval-back-image"
          onClick={() => {
            history.push("/home")
          }}
        >
          <img
            src={"../../../assets/images/back-icon.svg"}
            height={"60px"}
            width={"60px"}
            alt="back button"
            className="back_button"
          />
        </div>

        <div className="manage-staff-text">Prescription-Drug Catalog</div>
      </div>

      <div className="manage-patients-container">
        <div className="manage-patients-container">
          <div className="row add-new">
            <div className="col-9"></div>
            <div className="col-3 add-new-text">
              {/* <Button
                className="button-container"
                onClick={() => history.push(`/addManageStaff`)}
              >
                Add New Staff
              </Button> */}
            </div>
            <div className="search-container">
              <div>
                <GlobalFilter
                  filter={globalFilter}
                  setFilter={setGlobalFilter}
                />
              </div>
              <div>
                {/* <Dropdown placeholder="All" selected="" option=""></Dropdown> */}
              </div>
            </div>
            <div>
              <table
                {...getTableProps()}
                // @ts-ignore
                ref={componentRef}
              >
                <thead>
                  {headerGroups.map((headerGroup) => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map((column) => (
                        <th {...column.getHeaderProps()}>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-start",
                              paddingLeft: "10px",
                            }}
                          >
                            {column.render("Header")}
                          </div>
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>

                <tbody
                  className="border-radiusImportant"
                  {...getTableBodyProps()}
                >
                  {rows.map((row) => {
                    prepareRow(row)
                    return (
                      <tr {...row.getRowProps()} style={{ cursor: "pointer" }}>
                        {row.cells.map((cell) => {
                          return (
                            <td
                              onClick={() => {
                                //Add code to open the form
                              }}
                              style={{
                                maxWidth: "300px",
                                width: "300px",
                                wordWrap: "break-word",
                                maxHeight: "100px",
                                paddingLeft: "10px",
                                verticalAlign: "left",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                fontSize: "18px",
                                lineHeight: "24px",
                                letterSpacing: "1.35px",
                                textAlign: "initial",
                              }}
                              {...cell.getCellProps()}
                            >
                              {cell.render("Cell")}
                            </td>
                          )
                        })}
                      </tr>
                    )
                  })}
                </tbody>
                <tfoot>
                  {footerGroups.map((footerGroup) => (
                    <tr {...footerGroup.getFooterGroupProps()}>
                      {footerGroup.headers.map((column) => (
                        <td {...column.getFooterProps()}>
                          {column.render("Footer")}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tfoot>
              </table>
            </div>
          </div>
        </div>
        {displayToast && (
          <Toast
            // @ts-ignore
            textMessage={displayToast?.text}
            // @ts-ignore
            onClose={() => toggleDisplayToast(false)}
            onCloseText="Close"
            onClickText={
              // @ts-ignore
              displayToast?.onClickText ? displayToast?.onClickText : null
            }
            onClick={() =>
              // @ts-ignore
              displayToast?.patient
                ? // @ts-ignore
                handleDelete(displayToast?.patient)
                : null
            }
            // @ts-ignore
            type={displayToast?.type}
          />
        )}
      </div>
    </div>
  )
}
export default ManageStaff
